import { isSSR } from 'src/helpers/ssr';

export const START_ACTUALIZE_PACKAGE = 'START_ACTUALIZE_PACKAGE';
export const STOP_ACTUALIZE_PACKAGE = 'STOP_ACTUALIZE_PACKAGE';
export const ACTUALIZE_PACKAGE = 'ACTUALIZE_PACKAGE';
export const SET_ANALYTICS = 'SET_ANALYTICS';
export const ACTUALIZE_PACKAGE_SUCCESS = 'ACTUALIZE_PACKAGE_SUCCESS';
export const ACTUALIZE_PACKAGE_FAIL = 'ACTUALIZE_PACKAGE_FAIL';
export const SET_FRONT_ERROR = 'SET_FRONT_ERROR';

export const ACTUALIZATION_TIMEOUT =
  (!isSSR &&
    localStorage &&
    Number(localStorage.getItem('CHECKOUT_ACTUALIZATION_TIMEOUT'))) ||
  20 * 60 * 1000; // minutes * seconds * ms
export const PRICE_CHANGES_TIMEOUT = 20 * 1000; // seconds * ms

export const PRICE_CHANGE_DIRECTION = {
  DOWN: 'down',
  UP: 'up',
} as const;
